import { DataTexture, LinearFilter, LinearMipmapLinearFilter, RGBAFormat, type MeshStandardMaterial } from 'three'
import type { MachineDefinition } from '@core/machine'
import type asset from '../../SourceArt/PierContact/contacts.json'
let data: typeof asset | undefined
export async function prepareContactCoating():Promise<void>{data??=(await import('../../SourceArt/PierContact/contacts.json')).default}
export function contactCoatingFor(d:MachineDefinition){
  const t=data?.tables.find(t=>t.machineId===d.machineId)
  if(!t ||JSON.stringify([t.dimensions,t.colliders,t.devices,t.settings])!==JSON.stringify([d.dimensions.playfield,d.colliders,d.devices,d.settings??{}]))return undefined
  return t
}
/** One static linear mask, sampled in the existing board pass; emissive inserts remain separate. */
export function attachContactCoating(m:MeshStandardMaterial,d:MachineDefinition):void{
  const t=contactCoatingFor(d);if(!t)return
  const bytes=new Uint8Array(t.size[0]!*t.size[1]!*4);let cursor=0
  for(let i=0;i<t.rle.length;i+=2)for(let n=0;n<t.rle[i+1]!;n++){
    const v=t.rle[i]!;bytes.set([v,v,v,255],cursor);cursor+=4
  }
  if(cursor!==bytes.length)throw new Error('Invalid contact mask length')
  const map=new DataTexture(bytes,t.size[0],t.size[1],RGBAFormat)
  map.generateMipmaps=true;map.minFilter=LinearMipmapLinearFilter;map.magFilter=LinearFilter;map.needsUpdate=true
  const old=m.onBeforeCompile.bind(m);const key=m.customProgramCacheKey.bind(m)
  m.onBeforeCompile=(shader,renderer)=>{
    old(shader,renderer);shader.uniforms['uContactMap']={value:map};shader.uniforms['uContactEnabled']={value:contactCoatingFor(m.userData['contactDefinition'] as MachineDefinition)?1:0}
    m.userData['contactEnabled']=shader.uniforms['uContactEnabled']
    shader.fragmentShader='uniform sampler2D uContactMap;\nuniform float uContactEnabled;\n'+shader.fragmentShader
    shader.fragmentShader=shader.fragmentShader.replace('#include <map_fragment>','#include <map_fragment>\n#ifdef USE_MAP\ndiffuseColor.rgb *= mix(1.0,texture2D(uContactMap,vMapUv).r,uContactEnabled);\n#endif')
  }
  m.customProgramCacheKey=()=>key()+'/contact-coating-05'
  m.addEventListener('dispose',()=>map.dispose());m.userData['contactDefinition']=d
}
export function refreshContactCoating(m:MeshStandardMaterial|undefined,d:MachineDefinition):void{
  if(m)m.userData['contactDefinition']=d
  const u=m?.userData['contactEnabled'] as {value:number}|undefined
  if(u)u.value=contactCoatingFor(d)?1:0
}
